
<template>
  <v-container class="ma-0">
  <v-card class="ma-0 mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Ανταλλακτικά Επισκευών</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="lineItems"
      :search="search"
      loading: false
      item-key="Id"
      class="elevation-1"
      :loading="loading"
      loading-text="Loading... Please wait"
      single-expand: true
      show-group-by
      :expanded.sync="expanded"
    >
<template v-slot:top>
      <v-toolbar
        flat
        ma=8
      >
      <v-row>
            <v-col cols="12" sm="4">
              <v-combobox
                v-model="vehicle"
                :items="uniqueVehicles"
                prepend-icon="mdi-truck"
                label="Όχημα"
                chips
                multiple
                clearable
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="remove(vehicle, item)"
                  >
                    <strong>{{ item }}</strong
                    >&nbsp;
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
              <v-col cols="12" sm="4">
              <v-combobox
                v-model="tech"
                :items="uniqueTechs"
                prepend-icon="mdi-hammer-wrench"
                label="Τεχνικοί"
                chips
                multiple
                clearable
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="remove(tech, item)"
                  >
                    <strong>{{ item }}</strong
                    >&nbsp;
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
            </v-row>
        <v-spacer></v-spacer>
      </v-toolbar>
    </template>

<template v-slot:item.Timestamp="{ item }">
       {{  new Date(item.Timestamp).toLocaleDateString()  }}
    </template>
    
    <template v-slot:item.actions="{ item }">
             <v-btn
              class="mr-2"
              icon
              small
            :to="{name: 'edit-repair', params: {repairId: item.RepairId}, target: '_blank'}"
            >
              <v-icon>mdi-car-wrench</v-icon>
            </v-btn>
                </template>
     <template v-slot:item.Price="{ item }">
       {{ tocurr(item.Price) }}
    </template>
     <template v-slot:item.netvalue="{ item }">
       {{ tocurr(item.NetValue) }}
    </template>
    <template v-slot:item.totalvalue="{ item }">
       {{ tocurr(item.litem.price*item.litem.qty*1.24) }}
    </template>
    <template v-slot:item.vatvalue="{ item }">
       {{ tocurr(item.litem.price*item.litem.qty*0.24) }}
    </template>

     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        More info about {{ item.ItemCode }}
      </td>
    </template>



    </v-data-table>
  </v-card>
    </v-container>
</template>


<script>


export default {
  components: {
  },
  computed: {
  
    uniqueVehicles () {
      return this.uniq(this.lineItems, 'PlateNumber');
    },
     uniqueTechs () {
      return this.uniq(this.lineItems, 'Tech');
    },
  },
  data() {
    return {
      expanded: [],
      dialog: false,
      loading: true,
      search: '',
      vehicle: '',
      tech: '',
      customer_id: this.$route.params.gid,
      lineItems: [],
      headers: [
         {
            text: 'Ημ/νία',
            value: 'Timestamp',
            sortable: true,
            width: '5%',
            groupable: false,
          },
           {
            text: 'Όχημα',
            value: 'PlateNumber',
            sortable: true,
            width: '10%',
            groupable: true,
             filter: (value) => {
            if (this.vehicle.length == 0) return true;
            return this.vehicle.includes(value);
          }},
          { text: 'Κατασκευαστής', value: 'Manf', width: '10%' },
          { text: 'Κωδικός', value: 'Sku', width: '10%', groupable: true },
          { text: 'Περιγραφή', value: 'Description' },
           { text: 'Τεχνικός', value: 'Tech', sortable: false,
            filter: (value) => {
            if (this.tech.length == 0) return true;
            return this.tech.includes(value);
          }},
        { text: 'Ποσότητα', value: 'Qty', align: 'center', groupable: false  },
        { text: 'Μονάδα Μέτρησης', value: 'Unit', align: 'center', groupable: false  },
        { text: 'Τιμή', value: 'Price', align: 'end', groupable: false  },
        // { text: 'Καθαρή αξία', value: 'NetValue', align: 'end', groupable: false  },
        //  { text: 'ΦΠΑ', value: 'vatvalue', align: 'end', groupable: false },
        //  { text: 'Συνολο', value: 'totalvalue', align: 'end', groupable: false},
          { text: 'Actions', value: 'actions', groupable: false },
        ],
    }
  },
  async created() {
      try {
        this.loading = true
        let cid = this.$route.params.id
        const response = await this.$api.get("/inventory/parts/charge-hist",{ params: {customer_id: cid }});
        //console.log(response);
        this.lineItems = response.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  close () {
        this.timdialog = false
  },
  tocurr(value) {
    return new Intl.NumberFormat("el-GR", {
      style: "currency",
      currency: "EUR",
    }).format(value.toFixed(2));
  },
  uniq(items, key) {
      //Store the unique
      let uniques = [];

      //Track the items added to the uniques
      let itemsFound = {};
      for (let val of items) {
        //If item is already added then move to the next item
        if (itemsFound[val[key]]) {
          continue;
        }

        //Else push it to the unique list
        uniques.push(val[key]);

        //Mark it as added
        itemsFound[val[key]] = true;
      }

      //Return the uniques
      return uniques;
    },
    remove(obj, item) {
    obj.splice(obj.indexOf(item), 1);
    obj.vehicle = [...obj];
  },

  }
}
</script>
